// extracted by mini-css-extract-plugin
export var promotionLink = "_vj-0";